'use strict';


export default function() {
	return function filter(location) {
		if (location.street_number && location.route) {
			var address = `${location.street_number} ${location.route}`;
			if (location.locality) {
				address += `, ${location.locality}`;
			}
			if (location.administrative_level_1) {
				address += `, ${location.administrative_level_1}`;
			}
			return address;
		} else {
			return location.raw;
		}
	}
}
